import {createDiRootContainer} from '@/di/di.root-container';

import {ContainerProvider} from 'brandi-react';
import React, {PropsWithChildren, useMemo} from 'react';

import {useResourcesLoaderContext} from '@specials/resources';

import {ResourcesAll} from '@/resources';

export function AppDIContainer({children}: PropsWithChildren<unknown>): JSX.Element {
  const resources = useResourcesLoaderContext<ResourcesAll>();
  // создаем инстанс контейнера в отдельном компоненте внутри useMemo для того, чтобы избежать его ненужного создания на сервере
  // если в _app.tsx перенести компонент ContainerProvider и там вызывать createDiRootContainer, то будет создан лишний инстанс
  const container = useMemo(() => createDiRootContainer(resources), [resources]);

  return <ContainerProvider container={container}>{children}</ContainerProvider>;
}
